import { logToSentry } from "./logger";

// Shared rate-limit for the two automated recovery reloads (the sustained-broken backstop in
// useReloadOnUnrecoveredSubscription and the QR-drift zombie detector). ONE sessionStorage timestamp guards
// BOTH so they can't stack into a reload loop.
export const RECOVERY_RELOAD_STORAGE_KEY = "zombieReloadAt";
export const RECOVERY_RELOAD_STORM_WINDOW_MS = 5 * 60_000;

export const getLastRecoveryReloadAt = (): number => Number(sessionStorage.getItem(RECOVERY_RELOAD_STORAGE_KEY) ?? "0");

// last === 0 means no prior recovery reload recorded.
export const isWithinReloadStormWindow = (now: number, last: number): boolean =>
	last !== 0 && now - last < RECOVERY_RELOAD_STORM_WINDOW_MS;

// Reload NOW to recover, unless a recent recovery reload already happened (storm guard). Returns whether it
// reloaded. For a high-confidence one-shot signal (QR drift = a transaction was definitely missed) where a
// grace period buys nothing — unlike the sustained-broken backstop, which waits out a grace to let a live
// frame self-heal first.
export const reloadForRecoveryNow = (fridgeId: string, reason: string): boolean => {
	const now = Date.now();
	if (isWithinReloadStormWindow(now, getLastRecoveryReloadAt())) {
		logToSentry(`Recovery reload suppressed by storm guard (${reason}), fridge: ${fridgeId}`, "warning");
		return false;
	}
	sessionStorage.setItem(RECOVERY_RELOAD_STORAGE_KEY, String(now));
	logToSentry(`Reloading to recover (${reason}), fridge: ${fridgeId}`, "warning");
	window.location.reload();
	return true;
};
